/** Named overlay surfaces, matching the identifiers used by the original app. */

export const DRAWER_VIEW = {
  ABOUT: "ABOUT_DRAWER",
  CANCELLATION_POLICY: "CANCELLATION_POLICY_DRAWER",
  CONSUMER_DETAILS: "CONSUMER_DETAILS_DRAWER",
  DELIVERY_AREAS: "DELIVERY_AREAS_DRAWER",
  ITEM_OPTIONS: "ITEM_OPTIONS_DRAWER",
  OFFERS: "OFFERS_DRAWER",
  PRIVACY_POLICY: "PRIVACY_POLICY_DRAWER",
  // There is no `RECENT_ORDERS_DRAWER`. The original's only order-history view
  // is this one, and it holds a SINGLE order keyed off `drawer.props.order_id`;
  // the list is the inline rail on the menu page.
  RECENT_ORDER_DETAILS: "RECENT_ORDER_DETAILS_DRAWER",
  REFUND_POLICY: "REFUND_POLICY_DRAWER",
  REVIEWS: "REVIEWS_DRAWER",
  SHIPPING_POLICY: "SHIPPING_POLICY_DRAWER",
  /**
   * `97164.Yk` — the signed-in operator's orders for the current operational
   * day. Reached from the Account menu, behind `isStaff && POS_VIEW_REPORTS`.
   */
  STAFF_ORDERS: "STAFF_ORDERS_DRAWER",
  STORE_SCHEDULE: "STORE_SCHEDULE_DRAWER",
  TERMS_N_CONDITIONS: "TERMS_N_CONDITIONS_DRAWER",
  VERIFICATION: "VERIFICATION_DRAWER",
  /**
   * `97164.Vo` — the operator's own shift report. Its component is `ni`, NOT
   * `nn`: in this bundle `nn` is the avatar `Box` inside the report header.
   */
  X_REPORT: "X_REPORT_DRAWER",
} as const;

export const MODAL_VIEW = {
  /**
   * `32107.Q6` — the order-taker picker, opened from the checkout summary bar
   * and gated on `isStaff && POS_UPDATE_ASSIGN_ORDER_TAKER`.
   */
  ASSIGN_ORDER_TAKER: "ASSIGN_ORDER_TAKER_MODAL",
  DELIVERY_INFO: "DELIVERY_INFO_MODAL",
  DINEIN_NUM_OF_GUESTS: "DINEIN_NUM_OF_GUESTS_MODAL",
  DINE_IN_SEARCH_TABLES: "DINE_IN_SEARCH_TABLES_MODAL",
  ORDER_INSTRUCTIONS: "ORDER_INSTRUCTIONS_MODAL",
  RESERVATION: "RESERVATION_MODAL",
  SEARCH_ITEMS: "SEARCH_ITEMS_MODAL",
  SELECT_TIME: "SELECT_TIME_MODAL",
  /**
   * `32107.KL` — the staff card / access-code stack. The `_JOIN` suffix is the
   * original's own: it marks a modal whose body is a multi-screen stack rather
   * than a single surface.
   */
  STAFF_INFO_JOIN: "STAFF_INFO_MODAL_JOIN",
  STORE_STATUS: "STORE_STATUS_MODAL",
} as const;

interface PolicyDrawerConfig {
  title: string;
  settingsKey: string;
}

/** Static copy surfaces rendered by the generic policy drawer. */
export const POLICY_DRAWERS: Record<string, PolicyDrawerConfig> = {
  [DRAWER_VIEW.ABOUT]: { title: "About us", settingsKey: "about_us" },
  [DRAWER_VIEW.PRIVACY_POLICY]: {
    title: "Privacy Policy",
    settingsKey: "privacy_policy",
  },
  [DRAWER_VIEW.TERMS_N_CONDITIONS]: {
    title: "Terms & Conditions",
    settingsKey: "terms_and_conditions",
  },
  [DRAWER_VIEW.REFUND_POLICY]: {
    title: "Refund Policy",
    settingsKey: "refund_policy",
  },
  [DRAWER_VIEW.SHIPPING_POLICY]: {
    title: "Shipping Policy",
    settingsKey: "shipping_policy",
  },
  [DRAWER_VIEW.CANCELLATION_POLICY]: {
    title: "Cancellation Policy",
    settingsKey: "cancellation_policy",
  },
};

export type DrawerView = (typeof DRAWER_VIEW)[keyof typeof DRAWER_VIEW];
export type ModalView = (typeof MODAL_VIEW)[keyof typeof MODAL_VIEW];

export const OTP_TYPE_ENUM = {
  WHATSAPP: "WHATSAPP",
  SMS: "SMS",
} as const;

export type OtpType = (typeof OTP_TYPE_ENUM)[keyof typeof OTP_TYPE_ENUM];

/**
 * `ALL_OTP_TYPES` (module 77498) — `Object.values` of the original's enum,
 * which declares `SMS` first. **The order is rendered**: it is the order of the
 * "Receive OTP on" toggle buttons, so it is written out explicitly rather than
 * derived from the object above, whose key order differs.
 */
export const ALL_OTP_TYPES: OtpType[] = [
  OTP_TYPE_ENUM.SMS,
  OTP_TYPE_ENUM.WHATSAPP,
];
